module.exports = __webpack_public_path__ + "static/media/arrow-square-down.50914946.svg";